// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"h_n","reference__name":"h_p","reference__required":"h_q"};